export default __webpack_public_path__ + "static/media/myAthinaCover.a440c525.png";